import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Startup } from '../data/startups';
import { StartupCard } from './StartupCard';
interface StartupGridProps {
  startups: Startup[];
}
export function StartupGrid({
  startups
}: StartupGridProps) {
  return <section className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 min-h-[50vh]" data-id="element-138">
      <div className="mb-6 flex items-center justify-between" data-id="element-139">
        <h2 className="text-xl font-semibold tracking-tight text-neutral-900" data-id="element-140">
          All Startups
        </h2>
        <span className="text-sm text-neutral-500" data-id="element-141">
          Showing {startups.length} result{startups.length !== 1 ? 's' : ''}
        </span>
      </div>

      {startups.length === 0 ? <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-neutral-200 py-24 text-center" data-id="element-142">
          <div className="text-neutral-400 mb-2" data-id="element-143">No startups found</div>
          <p className="text-sm text-neutral-500" data-id="element-144">
            Try adjusting your search or category filter.
          </p>
        </div> : <motion.div layout className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-145">
          <AnimatePresence mode="popLayout" data-id="element-146">
            {startups.map((startup, index) => <motion.div key={startup.id} layout initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} transition={{
          duration: 0.25,
          ease: 'easeOut',
          delay: index * 0.05 // Stagger effect
        }} data-id="element-147">
                <StartupCard startup={startup} variant="compact" data-id="element-148" />
              </motion.div>)}
          </AnimatePresence>
        </motion.div>}
    </section>;
}